import { PRICING_RULE_TYPES } from '../constants/appConstants';

const DEFAULT_RULE = { type: PRICING_RULE_TYPES.NONE, value: 0 };

export function normalizePricingRule(rule) {
  if (!rule || typeof rule !== 'object') return { ...DEFAULT_RULE };
  return {
    type: rule.type || PRICING_RULE_TYPES.NONE,
    value: rule.value != null ? Number(rule.value) : 0,
  };
}

function pickCertifiedRule(rules, legacy) {
  const fromRules = rules?.certified;
  const fromLegacy = legacy;

  if (fromRules?.type && fromRules.type !== PRICING_RULE_TYPES.NONE) {
    return fromRules;
  }
  if (fromRules?.value != null && fromRules.value !== 0) {
    return fromRules;
  }
  if (fromLegacy?.type && fromLegacy.type !== PRICING_RULE_TYPES.NONE) {
    return fromLegacy;
  }
  if (fromLegacy?.value != null && fromLegacy.value !== 0) {
    return fromLegacy;
  }
  return fromRules || fromLegacy || DEFAULT_RULE;
}

export function resolvePricingRules(user) {
  const legacy = user?.pricingRule;
  const rules = user?.pricingRules || {};
  return {
    certified: normalizePricingRule(pickCertifiedRule(rules, legacy)),
    lots: normalizePricingRule(rules.lots),
  };
}

export function formatPricingRuleSummary(rule, t, currencySymbol = '$') {
  const normalized = normalizePricingRule(rule);
  if (normalized.type === PRICING_RULE_TYPES.NONE) {
    return t('clients.pricing.summaryNone');
  }
  const sign = normalized.value >= 0 ? '+' : '';
  if (normalized.type === PRICING_RULE_TYPES.PERCENTAGE) {
    return t('clients.pricing.summaryPercent', { sign, value: normalized.value });
  }
  return t('clients.pricing.summaryFixed', {
    sign,
    value: normalized.value,
    currency: currencySymbol,
  });
}

export const DEFAULT_PRICING_RULES_FORM = {
  certified: { ...DEFAULT_RULE },
  lots: { ...DEFAULT_RULE },
};

export function mapClientPricingToForm(client) {
  const rules = resolvePricingRules(client);
  return {
    pricingRules: {
      certified: { ...rules.certified },
      lots: { ...rules.lots },
    },
  };
}

export function buildPricingRulesPayload(form) {
  return {
    pricingRules: {
      certified: normalizePricingRule(form.pricingRules?.certified),
      lots: normalizePricingRule(form.pricingRules?.lots),
    },
  };
}
